import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useAppStore = defineStore('app', () => {
  const sidebarCollapsed = ref(false);
  const loading = ref(false);
  const theme = ref<'light' | 'dark'>('light');
  const notification = ref<{ type: 'success' | 'error' | 'warning' | 'info'; message: string } | null>(null);

  const isDarkMode = computed(() => theme.value === 'dark');

  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }

  function setSidebarCollapsed(collapsed: boolean) {
    sidebarCollapsed.value = collapsed;
  }

  function setLoading(value: boolean) {
    loading.value = value;
  }

  function setTheme(newTheme: 'light' | 'dark') {
    theme.value = newTheme;
    document.documentElement.classList.toggle('dark', newTheme === 'dark');
  }

  function toggleTheme() {
    setTheme(theme.value === 'light' ? 'dark' : 'light');
  }

  function showNotification(type: 'success' | 'error' | 'warning' | 'info', message: string) {
    notification.value = { type, message };
    setTimeout(() => {
      notification.value = null;
    }, 3000);
  }

  function clearNotification() {
    notification.value = null;
  }

  return {
    sidebarCollapsed,
    loading,
    theme,
    notification,
    isDarkMode,
    toggleSidebar,
    setSidebarCollapsed,
    setLoading,
    setTheme,
    toggleTheme,
    showNotification,
    clearNotification,
  };
});
